import React from 'react';
import { TitleHeader } from 'web-library';
import AccountActivated from '../../modules/admin/components/AccountActivated';
import { useWOGAA } from '../../hooks/wogaa';


const Activated = () => {
  const { transactionEnd } =  useWOGAA('myexamsseab-6476');

  /** WOGAA transaction tracking end
   * */
  transactionEnd();

  return (
    <>
      <TitleHeader state="success" title="Account successfully activated." />

      <AccountActivated />
    </>
  );
};

export default Activated;
